/**
 * Centralized colors and styles for designer mode component selection
 */

// Component selection colors (blue - default)
export const COMPONENT_SELECTION_COLOR = 'rgba(25, 118, 210, 1)'; // rgb(25, 118, 210)
export const COMPONENT_SELECTION_COLOR_LIGHT = 'rgba(25, 118, 210, 0.3)';
export const COMPONENT_SELECTION_COLOR_MEDIUM = 'rgba(25, 118, 210, 0.6)';
export const COMPONENT_SELECTION_COLOR_BG = 'rgba(25, 118, 210, 0.05)';

// ReferenceComponent selection colors (purple - to distinguish from regular components)
export const REFERENCE_SELECTION_COLOR = 'rgba(156, 39, 176, 1)'; // rgb(156, 39, 176) - purple
export const REFERENCE_SELECTION_COLOR_LIGHT = 'rgba(156, 39, 176, 0.3)';
export const REFERENCE_SELECTION_COLOR_MEDIUM = 'rgba(156, 39, 176, 0.6)';
export const REFERENCE_SELECTION_COLOR_BG = 'rgba(156, 39, 176, 0.05)';
export const REFERENCE_SELECTION_COLOR_HOVER_BG = 'rgba(156, 39, 176, 0.02)';
export const REFERENCE_LABEL_BG = 'rgba(255, 255, 255, 0.9)';

// Container empty state colors
export const CONTAINER_EMPTY_COLOR = 'rgba(158, 158, 158, 0.5)'; // gray

// Common styling constants
export const SELECTION_BORDER_RADIUS = '4px';
export const SELECTION_PADDING = '4px';
export const REFERENCE_LABEL_FONT_SIZE = '9px';
export const REFERENCE_LABEL_Z_INDEX = 1000;
